import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { SidenavComponent } from './shared/layout/sidenav/sidenav.component';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule, NgIf } from '@angular/common';
import { AuthService } from './auth/auth.service';
import { ToastComponent } from './shared/components/toast/toast.component';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SidenavComponent, TranslateModule, CommonModule, ToastComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title(title: any) {
    throw new Error('Method not implemented.');
  }
  
  // ✅ Usar Observable ao invés de string
  isAuthenticated$: Observable<boolean>;
  
  constructor(private router: Router, private authService: AuthService) {
    // ✅ Assinar o Observable de autenticação
    this.isAuthenticated$ = this.authService.isAuthenticated$;
  }

  ngOnInit() {
    const token = this.authService.getToken();
    if (token) {
      if (this.authService.isTokenExpired()) {
        this.authService.logout();
      } else {
        this.authService['startTokenTimer'](token); 
      }
    }
  }
}